import { useState, useEffect } from 'react';

// This returns the type of the value that is returned by a promise resolution
type ThenArg<T> = T extends PromiseLike<infer U> ? U : never;

export default function useDefaultDevices() {
  const [deviceInfo, setDeviceInfo] = useState<ThenArg<ReturnType<typeof getDeviceInfo>>>({
    audioInputDevice: undefined,
    videoInputDevice: undefined,
    audioOutputDevice: undefined,
    hasAudioInputDevices: false,
    hasVideoInputDevices: false,
  });

  useEffect(() => {
    if(navigator.mediaDevices) {
      const updateDeviceInfo = () => getDeviceInfo().then(devices => setDeviceInfo(devices));
      navigator.mediaDevices.addEventListener('devicechange', updateDeviceInfo);
      updateDeviceInfo();
      
      return () => {
        navigator.mediaDevices.removeEventListener('devicechange', updateDeviceInfo);
      };
    }
  }, []);

  async function getDeviceInfo() {
    if (navigator.mediaDevices) {

      let allDevices = await navigator.mediaDevices.enumerateDevices();
      return {
        audioInputDevice: allDevices.find(device => device.kind === 'audioinput' && device.deviceId === 'default'),
        audioOutputDevice: allDevices.find(device => device.kind === 'audiooutput' && device.deviceId === 'default'),
        videoInputDevice: allDevices.find(device => device.kind === 'videoinput' && device.deviceId === 'default'),
        hasAudioInputDevices: allDevices.some(device => device.kind === 'audioinput'),
        hasVideoInputDevices: allDevices.some(device => device.kind === 'videoinput'),
      };
    } else {
      return {
        audioInputDevice: undefined,
        audioOutputDevice: undefined,
        videoInputDevice: undefined,
        hasAudioInputDevices: undefined,
        hasVideoInputDevices: undefined,
      };
    }
  }

  return deviceInfo;
}
